import ReactPaginate from 'react-paginate'
import IconForward from '@/components/icons/IconForward'

import './Pagination.css'

const THREHOLD_OF_DISPLAY_ALL_PAGE = 9
const MAX_MARGIN_PAGE = 5

export default function Pagination({ page, pageCount, onPageChange }) {
  const showAllPage = pageCount <= THREHOLD_OF_DISPLAY_ALL_PAGE
  let pageRangeDisplayed = MAX_MARGIN_PAGE
  if (showAllPage) {
    pageRangeDisplayed = THREHOLD_OF_DISPLAY_ALL_PAGE
  } else if (page !== 0) {
    pageRangeDisplayed = MAX_MARGIN_PAGE - 1
    if (page === 3) {
      pageRangeDisplayed = 3
    } else if (pageCount - page <= 3) {
      pageRangeDisplayed = 5
    } else if (page >= 4) {
      pageRangeDisplayed = 3
    }
  }
  const marginPagesDisplayed = showAllPage ? undefined : 1

  const handlePageClick = ({ selected }) => onPageChange(selected)
  return (
    <ReactPaginate
      containerClassName="pagination"
      pageClassName="page-block"
      pageLinkClassName="page-link"
      breakLabel="..."
      breakLinkClassName="break-link"
      previousLabel={<IconForward />}
      previousLinkClassName="previous-link"
      nextLabel={<IconForward />}
      nextLinkClassName="next-link"
      onPageChange={handlePageClick}
      pageRangeDisplayed={pageRangeDisplayed}
      marginPagesDisplayed={marginPagesDisplayed}
      forcePage={page}
      pageCount={pageCount}
      renderOnZeroPageCount={null}
    />
  )
}
